<template>
    <div class="flex flex-col">
        <slot></slot>
    </div> 
</template>

<style>
.header-bg-color{
    background-color: #f4f4f4;
}

.text-color{
color: #636363;
}

.id-color{
color: #f7ab4d;
}

.tr-background-color{
background-color: #f9f9f9;
}



</style>